module.exports = __webpack_public_path__ + "assets/img/1661589449114_.pic_hd.3e15344f.jpg";